import { useState, type FormEvent } from 'react'

interface Props {
  companyName: string
  open: boolean
  busy: boolean
  onClose: () => void
  onConfirm: (note: string) => void
}

export default function AdminExemptDialog({ companyName, open, busy, onClose, onConfirm }: Props) {
  const [note, setNote] = useState('')

  if (!open) return null

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    const trimmed = note.trim()
    if (!trimmed || busy) return
    onConfirm(trimmed)
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      data-testid="admin-exempt-dialog"
      className="admin-dialog-backdrop"
      onClick={onClose}
    >
      <form className="admin-dialog-card" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <h2>Mark exempt</h2>
        <p>Set <strong>{companyName}</strong> to never billed (exempt). A note is required.</p>
        <textarea
          data-testid="admin-exempt-note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Why is this company exempt?"
          rows={3}
          required
        />
        <div className="admin-dialog-actions">
          <button type="button" className="btn b-ol" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className="btn primary" disabled={busy || !note.trim()} data-testid="admin-exempt-confirm">
            {busy ? 'Saving…' : 'Mark exempt'}
          </button>
        </div>
      </form>
    </div>
  )
}
